import { Navigate } from 'react-router-dom';
import { useAuth, type UserRole } from '../../stores/auth-context';

interface RoleGuardProps {
  children: React.ReactNode;
  roles: UserRole[];
}

export function RoleGuard({ children, roles }: RoleGuardProps) {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (!roles.includes(user.role)) {
    return <Navigate to="/monitoring" replace />;
  }

  return <>{children}</>;
}
